/* eslint-disable */
import { Col, Row, Container, Badge, Card, Button } from "react-bootstrap";
import {
  FaEnvelope,
  FaUser,
  FaCalendarAlt,
  FaInfoCircle,
  FaUsers,
} from "react-icons/fa";
import "./FormatComms.css";
import { capitalize } from "../../utils/textFormatters";

// Generated by GitHub Copilot

// Generated by GitHub Copilot
import dayjs from "dayjs";

const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

const dateFormat = "MM/DD/YYYY HH:mm z";

const FormatComms = (props) => {
  const communications =
    props && props.communications && props.communications
      ? props.communications
      : [];

  if (!communications || communications.length === 0) {
    return (
      <Container>
        <Row>
          <Col>
            <Card className="text-center">
              <Card.Body>
                <FaEnvelope className="mb-2 text-muted" size={24} />
                <Card.Text className="text-muted">
                  No communications have been sent for this problem.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">
              {communications.length} communication
              {communications.length !== 1 ? "s" : ""} sent
            </span>
          </div>
        </Col>
      </Row>

      {communications.map((comm, index) => {
        const sender = comm.sender.name ? comm.sender.name : "Unknown Agent";
        const badges = comm.statusPageRoutes.map((route) => (
          <Badge key={route.group.label} bg="success" className="me-1">
            {route.group.label}
          </Badge>
        ));

        return (
          <Row key={comm.id} className="mb-3">
            <Col>
              <Card className="comm-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="comm-info">
                      <h6 className="mb-2 comm-subject">
                        <FaEnvelope className="me-2" />
                        {comm.subject}
                      </h6>

                      <div className="comm-details">
                        <div className="detail-row">
                          <FaCalendarAlt className="me-1" />
                          <span className="detail-label">Sent:</span>
                          <span className="detail-value">
                            {dayjs(comm.createdAt).format(dateFormat)}
                          </span>
                          <span className="text-muted ms-2">
                            ({dayjs(comm.createdAt).fromNow()})
                          </span>
                        </div>

                        <div className="detail-row">
                          <FaUser className="me-1" />
                          <span className="detail-label">Sender:</span>
                          <span className="detail-value">{sender}</span>
                        </div>

                        <div className="detail-row">
                          <FaInfoCircle className="me-1" />
                          <span className="detail-label">Status:</span>
                          <span className="detail-value">
                            {comm.currentStatus}
                          </span>
                        </div>

                        {comm.reportedImpacts && comm.reportedImpacts.length > 0 && (
                          <div className="detail-row">
                            <FaUsers className="me-1" />
                            <span className="detail-label">Reported Impacts:</span>
                            <span className="detail-value">
                              {comm.reportedImpacts.map((impact, i) => (
                                <span key={i} className="me-2">
                                  {impact.status && (
                                    <span className={`badge me-1 ${impact.status?.toLowerCase() === "active" ? "bg-danger" : "bg-secondary"}`}>
                                      {capitalize(impact.status)}
                                    </span>
                                  )}
                                  {impact.brand ?? ""} – {impact.workload ?? ""}
                                  {impact.incidentTicket ? ` (${impact.incidentTicket})` : ""}
                                  {i < comm.reportedImpacts.length - 1 ? "," : ""}
                                </span>
                              ))}
                            </span>
                          </div>
                        )}

                        {badges.length > 0 && (
                          <div className="detail-row">
                            <FaUsers className="me-1" />
                            <span className="detail-label">Groups:</span>
                            <span className="detail-value">{badges}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        );
      })}
    </Container>
  );
};

export { FormatComms };
